import alertComponent from './Alert.vue'

const Alert = {
  install: function (Vue) {
    Vue.component('Alert', alertComponent)
  }
}
export default Alert



// WEBPACK FOOTER //
// ./src/components/alert/index.js